import React, { useMemo, useState } from 'react'
import { Form } from 'react-bootstrap'

import { selectNewEmailResult } from '../../../store/emailHub/newEmail'
import { useAppSelector } from '../../../store/hooks'

import { Button } from '../../../components/Button/Button'

import { isNewEmailNoResult } from './utils'
import { useExecuteNewEmail } from './hooks'
import { EmailType } from '../../../models/EmailType'

const _NEW_EMAIL_GENERATOR_INPUT_PLACEHOLDER = 'Describe what you want this email to accomplish\u2026'

interface NewEmailGeneratorProps {
  emailType: EmailType | 'custom'
}

export const NewEmailGenerator: React.FC<NewEmailGeneratorProps> = ({ emailType }) => {
  const newEmailResult = useAppSelector(selectNewEmailResult)

  const [emailDescription, setEmailDescription] = useState<string>('')

  const isNoResult = useMemo(() => isNewEmailNoResult(newEmailResult), [newEmailResult])

  const { handleNewEmailExecution } = useExecuteNewEmail()

  const handleEmailDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setEmailDescription(e.target.value)
  }

  const handleGenerateButtonClick = () => {
    handleNewEmailExecution(emailType, emailDescription)
  }

  const isCustom = emailType === 'custom'

  return (
    <div className='d-flex flex-column gap-2 align-items-center'>
      {isNoResult || isCustom ? (
        <div className='d-flex flex-column gap-3 w-100'>
          {isNoResult ? (
            <>
              <span className='paragraph-large bold'>Additional context needed due to limited insights</span>
              <span className='paragraph-medium'>
                To ensure a better response, we need additional context beyond the current insights from CRM and financial tools. Briefly describe what
                information to include.
              </span>
            </>
          ) : isCustom ? (
            <span className='paragraph-medium'>
              Describe what you want this email to accomplish. Include key points, and any insights from CRM and financial tools
            </span>
          ) : null}
          <Form.Control
            as='textarea'
            value={emailDescription}
            onChange={handleEmailDescriptionChange}
            rows={4}
            placeholder={_NEW_EMAIL_GENERATOR_INPUT_PLACEHOLDER}
          />
        </div>
      ) : null}
      <Button variant='primary' className='py-1 px-2' onClick={handleGenerateButtonClick} disabled={(isNoResult || isCustom) && !emailDescription.length}>
        Generate Email
      </Button>
    </div>
  )
}
